var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header'),_c('Foucs',{attrs:{"banners":_vm.home.banners}}),_c('div',{staticClass:"main"},[_c('Product',{attrs:{"products":_vm.home.products,"brands":_vm.home.productbrands},on:{"onBrandId":_vm.onBrandId}}),_c('Service'),_c('Process'),_c('FooterSlogan')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }